import { Logger } from "@core/helpers/logger.helpers";

export class ExceptionManager {
  /**
   * Catch all javascript errors throught the window.onerror event
   * https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror
   * @static
   * @memberof ExceptionManager
   */
  static setOnErrorBehavior() {
    window.onerror = (message, url, lineNo, columnNo, error) => {
      const string = message.toLowerCase();

      // ResizeObserver loop limit exceeded
      // we can safely ignore this one
      // source: https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
      if (string.indexOf("resizeobserver") > -1) {
        // do not throw this
        return true;
      }

      const errorObj = {
        type: "js.error",
        error: {
          message,
          url,
          line: lineNo,
          col: columnNo,
          errorObject: JSON.stringify(error),
        },
      };

      Logger.log(errorObj);

      throw errorObj;
    };
  }
}
